import Component from "vue-class-component";
import Vue from "vue";
import { DataEntityStock, ProductsStock } from "@/entity/warehouse/Products/ProductsStock.types";
import { ProductsStockStore } from "@/store/modules/Warehouse/ProductsStock";

@Component
export class ProductsStockMix extends Vue {
    get productsStocks(): ProductsStock | null {
        return ProductsStockStore.items;
    }
    get getProductsStocksTree(): Array<any> | null {
        const dtreeData: any[] = [];
        if (ProductsStockStore && ProductsStockStore.items && ProductsStockStore.items.data) {
            ProductsStockStore.items.data.forEach((key, item) => {
                dtreeData.push({ title: key["nomenclature"]["name"], key: key["id"] });
            });
        }
        return dtreeData;
    }
    get productStock(): DataEntityStock | null {
        return ProductsStockStore.item;
    }
    async getStockProducts(store_id: number): Promise<void> {
        await ProductsStockStore.fetchAll({
            filter: { store_id: store_id, quantity: '>0' },
        });
    }
    async getStockProduct(id: number): Promise<void> {

        await  ProductsStockStore.fetchAll({filter:{id:id}});
    }


    getSelectItems(): DataEntityStock[] | null | undefined {
        return this.productsStocks !== undefined && this.productsStocks !== null ? this.productsStocks.data : [];
    }
}
